let videoDetails = null;

/**
 * Load and initialize tracking.
 * @param {{ id: string, language: string, state: string }} details video details used for tracking
 */
function init({ id, language, event_state }) {
  return new Promise((res) => {
    const url = process.env.MATOMO_URL;
    if (!url) {
      res();
    } else {
      window._paq = window._paq || [];
      window._paq.push(["setTrackerUrl", `${url}/matomo.php`]);
      window._paq.push(["setSiteId", "1"]);
      const g = document.createElement("script");
      const s = document.getElementsByTagName("script")[0];
      g.onload = () => {
        videoDetails = {
          id,
          language,
          event_state,
        };
        res();
      };
      g.onerror = () => res();
      g.type = "text/javascript";
      g.async = true;
      g.src = `${url}/matomo.js`;
      s.parentNode.insertBefore(g, s);
    }
  });
}

function sendViewEvent() {
  if (!videoDetails) return;
  window._paq.push([
    "setCustomUrl",
    `/${videoDetails.id} >> ${videoDetails.event_state}`,
  ]);
  window._paq.push(["setDocumentTitle", JSON.stringify(videoDetails)]);
  window._paq.push(["trackPageView"]);
}

/**
 * @param {string} clickName
 */
function sendClickEvent(clickName) {
  if (!videoDetails) return;
  const eventName = `${videoDetails.id} >> ${videoDetails.event_state}`;
  window._paq.push(["trackEvent", clickName, "click", eventName]);
}

/**
 * @param {string} type
 */
function sendMediaEvent(type) {
  if (!videoDetails) return;
  const eventAction = `${videoDetails.id} >> ${videoDetails.language} >> ${videoDetails.event_state}`;
  const eventName = `${eventAction} >> ${type}`;
  window._paq.push(["trackEvent", eventAction, "media", eventName]);
}

function sendPlayMediaEvent() {
  sendMediaEvent("play");
}

/**
 * @param {string} language
 */
function updateLanguage(language) {
  if (!videoDetails) return;
  videoDetails.language = language;
}

export default {
  init,
  sendViewEvent,
  sendClickEvent,
  sendMediaEvent,
  sendPlayMediaEvent,
  updateLanguage,
};
